import { gql, TypedDocumentNode } from "@apollo/client";

import { Maybe, QueryRevisionArgs, Revision } from "types/generated";

export const GET_SPACELIFT_VCS_REPO_REVISION: TypedDocumentNode<
  { revision: Maybe<Revision> },
  QueryRevisionArgs
> = gql`
  query GetSpaceliftVcsRepoRevision($repoID: ID!, $sha: String) {
    revision(repoID: $repoID, sha: $sha) {
      id
      sha
      message
      description
      authorName
      authorEmail
      createdAt
      files {
        filePath
        isDeleted
      }
    }
  }
`;
